<template>
    <secondary-button
        v-bind="$attrs"
        @click="$emit('click', $event)"
    >
        <v-icon left>mdi-chevron-left</v-icon>
        <slot />
    </secondary-button>
</template>

<script>
export default {
    name: "BackButton"
}
</script>
